import { motion } from 'framer-motion';
import siteData from '../siteData';

function Reveal({ 
  children, 
  className,
  onRender = false,
  inView = true,
  direction = "up",
  order = 1,
  duration = .5,
  threshold = 0,
  fade = true,
  grow = true,
  move = true,
  force = false,
  delay,
  ...props
}) {
  let initial = {}, active = {};
  if (delay === undefined) {
    delay = order * .15;
  }
  if (siteData.animations.on || force) {
    if (fade) {
      initial.opacity = 0;
      active.opacity = 1;
    }
    if (grow) {
      initial.scale = 0.95;
      active.scale = 1;
    }
    if (move) {
      if (direction === 'up') {
        initial.y = '3.5vh';
        active.y = 0;
      }
      else if (direction === 'down') {
        initial.y = '-3.5vh';
        active.y = 0;
      }
      else if (direction === 'left') {
        initial.x = '3.5vh';
        active.x = 0;
      }
      else if (direction === 'right') {
        initial.x = '-3.5vh';
        active.x = 0;
      }
    }
  }
  
  return (
    <motion.div
      className={className}
      initial={initial}
      whileInView={inView ? active : {}}
      animate={onRender ? active : {}}
      transition={{ duration, delay, ease: "easeOut" }}
      viewport={{ once: siteData.animations.once, amount: threshold }}
      {...props}
    >
      {children}
    </motion.div>
  );
}

export default Reveal;